import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Typography, Divider, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { compose } from '../../utils/compose';
import {connect} from 'react-redux';
import { subscriptionBaseUrl, httpClient } from '../../http-client/http-client';
import PlanCard from '../Plans/PlanCard';
import PriceDetails from './PriceDetails';


const ReactivateEstimateDialog = props => {
  const { onClose, open, access_token, ...other } = props;
  const [ estimateData, setEstimateData ] = useState({ fetching: true, data: null, error: null, invoiceEstimate: null })
  const { t } = useTranslation();
  const [ error, setError ] = useState(null);
  const [ submitting, setSubmitting ] = useState(false);

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      const url = `${subscriptionBaseUrl}/estimate`;

      try {
        const data = await httpClient.post(url, access_token);
        let cest = data.Estimate.InvoiceEstimate;
        if(cest === null) {
          cest = data.Estimate.NextInvoiceEstimate;
        }

        if(isActive) {
          setEstimateData({
            fetching: false,
            data: data,
            error: null,
            invoiceEstimate: cest
          });
        }
      }
      catch(error) {
        if(isActive) {
          setEstimateData({
            fetching: false,
            data: null,
            error: error.error.HumanError,
            cest: null
          });
        }
      }

    }

    fetchData();

    return () => {
      isActive = false;
    }
  }, [access_token]);

  function handleCancel() {
    onClose(false);
  }

  async function handleOk() {

    const url =`${subscriptionBaseUrl}/reactivate`;
    setSubmitting(true);
    try {
      await httpClient.post(url, access_token);
      setSubmitting(false);
      onClose(true);
    }
    catch(error) {
      setError(error.error.HumanError);
      setSubmitting(false);
    }
  }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="reactivate-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="reactivate-dialog-title">{t('subscriptionReactivate')}</DialogTitle>
      <DialogContent dividers>
        { estimateData.fetching
          ? <Typography component="div" align="center"><CircularProgress /></Typography>
          : (
            <>
              <PlanCard plan={estimateData.data.Plan}></PlanCard>
              <Divider />
              <Typography variant="h6">{t('priceDetails')}</Typography>
              <PriceDetails invoiceEstimate={estimateData.invoiceEstimate} />
            </>
          )}
      </DialogContent>
      <DialogActions>
        <FormHelperText className="Mui-error">{error}</FormHelperText>
        <Button onClick={handleCancel} color="primary" disabled={submitting}>{t('cancel')}</Button>
        <Button onClick={handleOk} color="primary" disabled={submitting}>{submitting ? <CircularProgress size={16} /> : null}{t('OK')}</Button>
      </DialogActions>
    </Dialog>
  );
};

ReactivateEstimateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  access_token: state.oidc.user.access_token
});

const mapDispatchToProps = dispatch => ({

});

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ReactivateEstimateDialog)

export default composed;